import Vue from '@/static/js/myVue.js'
import store from '@/store'
import App from './App.vue'
import axios from '../../static/js/request'
import VueAxios from 'vue-axios'
import VueLazyload from 'vue-lazyload'
import router from '../../router/answer'
import { getQueryStr, Popup } from '@/static/js/zjs.js'
import VueTouch from 'vue-touch'
// 初始化必须的数据，openid验证
import * as wechatJsSdk from '@/plugin/wechatJSSdk'

import '@/static/css/reset.css'
import '@/static/js/rem.js'
import '@/static/js/pop.js'
import '@/directives/trackevent.js'
import '@/directives/mask.js'
import '@/plugin/vant'
// import './ad2'
import '@/pages/todo/g/tip.js'

import { getPlatform } from '@/static/js/zjs'
import { getCookie } from '@/static/js/zjs.js'
import { setDefaultShareInfo, share } from '../../plugin/wechatJSSdk'
import beforeLoadVueInstance from '../../plugin/beforeLoadVueInstance'

const main = async function () {


  Vue.use(wechatJsSdk, {
    jsApiList: [
      'scanQRCode',
      'closeWindow',
      'updateAppMessageShareData',
      'updateTimelineShareData',
      'previewImage',
      "chooseImage",
      "getLocalImgData",
      "uploadImage",
    ],
    defaultShare: true
  })

  router.afterEach((next) => {
    console.log('分享', next)
    if (next.fullPath === '/findBook/findScanQr') {
      share({
        title: '求书',
        desc: '新华书店唯一指定授权,作业检查利器,强烈推荐！',
        link: `https://${window.location.host}/cms/webapp/home/answer/index.html#/findBook/findScanQr`,
        imgUrl: `https://${window.location.host}/cms/static/images/logo-128.png`,
        success: function () { },
        cancel: function () { }
      })

    } else {
      setDefaultShareInfo()
    }
  })

  // window.baseURL = process.env.VUE_APP_baseURL

  Vue.use(VueTouch, { name: 'v-touch' })
  Vue.use(VueLazyload, {
    preLoad: 1.3,
    attempt: 1
  })
  Vue.use(VueAxios, axios)
  Vue.config.productionTip = false
  Vue.prototype.$pop = new Popup()

  await beforeLoadVueInstance(router)
  window.vapp = new Vue({
    render: (h) => h(App),
    router,
    store
  }).$mount('#app')

  window.Vue = Vue

  if (vapp.$store && u.db) {
    u.db.st = vapp.$store.state
    u.db.openid = getCookie('openid')
    u.db.appid = getPlatform().appid
    u.db.pf = getPlatform().platform
  }
}

if (getQueryStr('inspect')) {
  window.start = main
} else {
  main()
}
